import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { Box } from '@mui/material';

import { styles } from './styles';
import SuspenseLoading from '@components/common/SuspenseLoading';

export type NotFoundLayoutProps = {};

const NotFoundLayout: React.FC<NotFoundLayoutProps> = () => {
  return (
    <Box sx={styles.root}>
      <Suspense fallback={<SuspenseLoading />}>
        <Outlet />
      </Suspense>
    </Box>
  );
};

export default NotFoundLayout;
